export default class Category {
    constructor(name, color, blocks){
        this.name = name
        this.color = color
        this.blocks = blocks.map(element => {
            //console.log(element)
            return element.createInstance(color)})
    }
}